import { AxiosError } from 'axios';
import instance from '../config/axios';

export const fetchPatientDosageDiaries = async (token: string) => {
  try {
    const result = await instance({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: '/api/v1//dosasgedairy/patient',
    });

    return result.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
};
